<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增商品投放</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            :group="group"
            group-select
            @input-group-option="inputGroupOption"
        ></app-base-info>
        <app-product-target-picker
            ref="picker"
            bid-input
            showSuggestedBidding
            :market-id="marketId"
            :formBase="form.baseInfoForm"
            bidLabelWidth="119px"
            :form="form.productTargetPickerForm"
            :ad-product$="adProduct$"
            title="商品投放"
        ></app-product-target-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "@/minxins";
  import AppBaseInfo from "../common/base-info";
  import AppProductTargetPicker from "../common/product-target-picker";
  import {AdGroupEnum} from "modules/ad/common/enum";
  import { getSpAdProductPage, SP } from "@/api/ad";
  import {defaultVal, isMeaningful} from "@/utils/common";

  export default {
    name: "app-add-sp-ad-product-target",
    mixins: [modalMixIn],
    components: {AppProductTargetPicker, AppBaseInfo},
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SP.targetingType.PRODUCT,
            campaignId: null,
            groupId: null,
            expressionType: null
          },
          productTargetPickerForm: {
            items: [],
            bid: null
          }
        },
        adProduct$: null,
      }
    },
    watch: {
      group: {
        handler: function(group) {
          if (isMeaningful(group)) {
              this.$nextTick(() => {
                  this.inputGroupOption({
                      id: group.groupId,
                      bid: group.bid
                  });
              });
          }
        },
        immediate: true
      }
    },
    computed: {
      modalClass() {
        if (isMeaningful(this.group)) {
          return 'gj-modal_1220X677';
        } else {
          return 'gj-modal_1220X719';
        }
      }
    },
    methods: {
      inputGroupOption(option) {
        if (isMeaningful(option)) {
          //广告活动-商品投放-新增商品投放，查询列表逻辑优化，少调一个接口
          this.adProduct$ = Promise.resolve(option.id)
          // this.adProduct$ = SP.productPage({
          //   model: {
          //     marketId: this.marketId,
          //     campaignIds: [ this.form.baseInfoForm.campaignId ],
          //     groupIds: [ option.id ],
          //   },
          //   current: 1,
          //   size: 99999
          // }).then((res) => {
          //   return Promise.resolve(res.data);
          // });
          this.form.productTargetPickerForm.bid = option.bid;
        }
      },
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'picker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.targetsAdd())
          .catch((error) => console.log('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      targetsAdd() {
          this.confirmLoading = true;
          const params = {
            marketId: this.marketId,
            params: this.form.productTargetPickerForm.items.map(item => {
              const productTargetParams = {
                bid: item.bid,
                groupId: this.form.baseInfoForm.groupId,
                campaignId: this.form.baseInfoForm.campaignId,
                expressionType: this.form.baseInfoForm.expressionType, // 投放类型：'0'：商品投放，'1'：投放组
              };
              productTargetParams.categoryId = defaultVal(item.categoryId, null);
              productTargetParams.categoryName = defaultVal(item.categoryName, null);
              productTargetParams.asin = defaultVal(item.asin, null);
              productTargetParams.brandId = defaultVal(item.brandId, null);
              productTargetParams.brandName = defaultVal(item.brandName, null);
              productTargetParams.minPrice = defaultVal(item.lowPrice, null);
              productTargetParams.maxPrice = defaultVal(item.maxPrice, null);
              productTargetParams.minMarks = (item.marks && item.marks.length !== 0) ? item.marks[0] : null;
              productTargetParams.maxMarks = (item.marks && item.marks.length !== 0) ? item.marks[1] : null;
              productTargetParams.prime = defaultVal(item.prime, null);

              return productTargetParams;
            })
          };
          SP.targetsAdd(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
        
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
